export default __webpack_public_path__ + "static/media/5.3fa6ea46.jpeg";